/**
 * Bottom Navigation - Enterprise Design v2.0
 * QRIUM Recvisit
 * 
 * Соответствует Samsung OneUI Design Guidelines:
 * - Touch targets минимум 44x44px
 * - Четкая визуальная иерархия
 * - Плавные переходы
 */
import { memo } from 'react'

type NavItem = 'events' | 'manual' | 'charts' | 'sync' | 'more'

interface Props {
  active: NavItem
  onChange: (item: NavItem) => void
}

const navItems: { id: NavItem; icon: string; label: string }[] = [
  { id: 'events', icon: '📋', label: 'События' },
  { id: 'manual', icon: '✏️', label: 'Отметка' },
  { id: 'charts', icon: '📊', label: 'Графики' },
  { id: 'sync', icon: '🔄', label: 'Синхр.' },
  { id: 'more', icon: '⚙️', label: 'Ещё' },
]

export const BottomNavigation = memo(function BottomNavigation({ active, onChange }: Props) {
  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-[#0d0d0d]/95 backdrop-blur-xl border-t border-[#1f1f1f] safe-area-bottom z-50">
      <div className="flex items-stretch h-[72px] px-2">
        {navItems.map((item) => (
          <NavButton
            key={item.id}
            icon={item.icon}
            label={item.label}
            active={active === item.id}
            onClick={() => onChange(item.id)}
          />
        ))}
      </div>
    </nav>
  )
})

function NavButton({ icon, label, active, onClick }: { 
  icon: string
  label: string
  active: boolean
  onClick: () => void 
}) {
  return (
    <button
      onClick={onClick}
      className={`
        flex-1 flex flex-col items-center justify-center gap-1
        min-w-[56px] min-h-[56px]
        transition-all duration-150
        touch-manipulation
        active:scale-95 active:opacity-80
        ${active ? 'text-[#3b82f6]' : 'text-[#6b6b6b]'}
      `}
    >
      <span className={`text-[24px] transition-transform duration-150 ${active ? 'scale-110' : ''}`}>
        {icon}
      </span>
      <span className={`text-[11px] font-medium tracking-tight ${active ? 'text-[#3b82f6]' : 'text-[#6b6b6b]'}`}>
        {label}
      </span>
    </button>
  )
}
